var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('OzListRow',{attrs:{"dark-mode":_vm.darkMode,"separator":_vm.separator,"clickable":_vm.clickable},on:{"click":_vm.select},scopedSlots:_vm._u([{key:"left",fn:function(){return [_c('ImageThumbnail',{class:[
        'rounded-lg rounded-br-2xl rtl:rounded-br-lg rtl:rounded-bl-2xl',
        'mr-4 rtl:mr-0 rtl:ml-4',
        'flex-shrink-0',
      ],attrs:{"src":_vm.wall.thumbnail.url,"title":_vm.wall.title,"placeholder-color-value":_vm.dominantColorAsRgb,"placeholder-color":'random',"fallback-to-placeholder":true,"original-image-width":_vm.wall.thumbnail.width,"original-image-height":_vm.wall.thumbnail.height,"width":36,"process-image":true,"aspect-ratio":1}})]},proxy:true},(_vm.xMore)?{key:"right",fn:function(){return [_c('OzTextButton',{class:['w-11', 'h-11', 'flex', 'justify-end', 'items-center'],attrs:{"color-scheme":_vm.OzTextButtonColorScheme.SecondaryMuted,"data-cy":_vm.title,"aria-label":_vm.__('More')},on:{"click":function($event){$event.stopPropagation();return _vm.more.apply(null, arguments)}}},[_c('OzIcon',{attrs:{"name":"more_vertical"}})],1)]},proxy:true}:null],null,true)},[_vm._v(" "),_c('div',{staticClass:"my-2 relative overflow-hidden"},[_c('div',{class:[
        'text-17-21',
        'font-semibold',
        _vm.invertColors
          ? {
              'text-dark-text-100': _vm.darkMode === true,
              'text-light-text-100': _vm.darkMode === false,
              'dark:text-dark-text-100 text-light-text-100': _vm.darkMode === 'auto',
            }
          : {
              'text-light-text-100': _vm.darkMode === true,
              'text-dark-text-100': _vm.darkMode === false,
              'text-dark-text-100 dark:text-light-text-100': _vm.darkMode === 'auto',
            },
        'truncate',
      ]},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),_c('div',{class:[
        'text-body-extra-small',
        'flex',
        'leading-4',
        _vm.invertColors
          ? {
              'text-dark-text-100': _vm.darkMode === true,
              'text-light-text-100': _vm.darkMode === false,
              'dark:text-dark-text-100 text-light-text-100': _vm.darkMode === 'auto',
            }
          : {
              'text-light-text-200': _vm.darkMode === true,
              'text-dark-text-200': _vm.darkMode === false,
              'text-dark-text-200 dark:text-light-text-200': _vm.darkMode === 'auto',
            },
      ]},[_c('span',[_vm._v(_vm._s(_vm.builderDisplayName))]),_vm._v(" "),_c('span',{class:[
          _vm.invertColors
            ? {
                'text-dark-text-300': _vm.darkMode === true,
                'text-light-text-300': _vm.darkMode === false,
                'text-light-text-300 dark:text-dark-text-300': _vm.darkMode === 'auto',
              }
            : {
                'text-light-text-300': _vm.darkMode === true,
                'text-dark-text-300': _vm.darkMode === false,
                'text-dark-text-300 dark:text-light-text-300': _vm.darkMode === 'auto',
              },
        ]},[_vm._v(" • ")]),_vm._v(" "),_c('RelativeTime',{attrs:{"datetime":_vm.date,"dateformat":"short"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }